var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',{staticClass:"news-carousel"},[_c('slick',{attrs:{"options":_vm.slickOptions}},_vm._l((_vm.items),function(item){return _c('NewsPoster',{key:item.id,attrs:{"resource":item}})}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }